import React from "react";
import Box from "@mui/material/Box";
import { useStyles } from "./styles";

export const LoadingSpinner: React.FC = () => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <Box className={classes.root}>
        <span className={classes.jumpingDot}></span>
        <span className={classes.jumpingDot}></span>
        <span className={classes.jumpingDot}></span>
      </Box>
      <Box className="moving-gradient"></Box>
    </React.Fragment>
  );
};

export default LoadingSpinner;
